import React from 'react'
import { Row, Col, Button } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'

export const Next = ({ title, disabled, ...props }) => {
  return (
    <Row justify='end' align='middle' className='stretched'>
      <Col>
        <Button type='primary' title='next' disabled={disabled} {...props}>
          {title}
          <ArrowRightOutlined />
        </Button>
      </Col>
    </Row>
  )
}
